module.exports = "/img/team-member-1.4020d236.png";